module.exports = __webpack_public_path__ + "img/pjykp1.0cd9adee.png";